export const getWhatsAppUrl = (phone) => {
  let digits = String(phone ?? "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  // Local profile numbers use India's country code.
  if (digits.length === 10) digits = `91${digits}`;
  if (!/^[1-9]\d{10,14}$/.test(digits)) return undefined;
  return `https://wa.me/${digits}`;
};
